import { createServerFn } from '@tanstack/react-start'
import { getPresignedMediaUrl } from '../../lib/s3'
import { getMediaUrlsSchema } from './mediaSchemas'

/** Fresh presigned GET URLs for a set of media keys, keyed by S3 key */
export const getMediaUrls = createServerFn({ method: 'POST' })
  .inputValidator(getMediaUrlsSchema)
  .handler(async (ctx): Promise<Record<string, string>> => {
    const entries = await Promise.all(
      ctx.data.keys.map(
        async (key) => [key, await getPresignedMediaUrl(key)] as const,
      ),
    )
    return Object.fromEntries(entries)
  })
